// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_ydb","cls2":"ChatInterface-cls2_151 ChatInterface-cls1_ydb"};